import { configureStore } from "@reduxjs/toolkit";
import gameReducer from "./game/GameSlice";
import userReducer from "./user/UserSlice";
import lobbyReducer from "./lobby/LobbySlice";
import uiStateReducer from "./uiState/UiStateSlice";
import audioReducer from "./audio/AudioStateSlice";

const store = configureStore({
  reducer: {
    userReducer,
    gameReducer,
    lobbyReducer,
    uiStateReducer,
    audioReducer,
  },
});

export default store;

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
